<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">名称</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> 
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getKryOrderInquiryFn()">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">     	  
	  <el-table-column align="center" prop="orderId"         label="订单编号">      </el-table-column>
	  <el-table-column align="center" prop="tradeNo" 		 label="订单编号">      </el-table-column>
      <el-table-column align="center" prop="tradeTypeStr"       label="交易类型">      </el-table-column>
      <el-table-column align="center" prop="tradeStatusStr"     label="订单状态">      </el-table-column>
      <el-table-column align="center" prop="orderTimeStr"       label="下单时间">      </el-table-column>
	  <el-table-column align="center" prop="checkOutTimeStr"    label="结帐时间">      </el-table-column>
	  <el-table-column align="center" prop="sourceStr"          label="订单来源">      </el-table-column>
	  <el-table-column align="center" prop="sourceName"      label="订单来源名称">   </el-table-column>
	  <el-table-column align="center" prop="receivedAmountStr"  label="商户实收金额">   </el-table-column>
	  <el-table-column align="center" prop="custRealPayStr"     label="用户实付金额">   </el-table-column>
	  <el-table-column align="center" prop="tradeAmountStr"     label="订单原始金额">   </el-table-column>
	  <el-table-column align="center" prop="privilegeAmountStr" label="优惠总金额">     </el-table-column>
	  
	  <el-table-column align="center" width="200" label="操作">
	    <template slot-scope="{row}">
	      <a class="glob-a" @click="statusBtn(3, row)">查看</a>
	    </template>
	  </el-table-column>
	  
	</el-table>  
	  
	<!-- 详情 -->
	<el-dialog title="查看" :visible.sync="detailModal" fullscreen>
	  <detail :id="detailId"/>
	</el-dialog>
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
  </div>
</template>

<script>
  import Detail from './Detail.vue'
	
  import {
    getKryOrderInquiry
  } from '@/api'

  export default {
	name: 'orderList',
	components: {Detail},
    data () {
      return {
        date: [],
        status: '',
        city: [],
        cityList: [],
        agent: '',
        agentList: [],
        name: '',
        phoneNumber: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
        // 状态
        statusData: {
          modal: false,
          userId: '',
          type: '',
          typeName: '',
          date: [],
          content: ''
        },
		createTime:'',
		updateTime:''
      }
    },
    created () {
        this.getKryOrderInquiryFn()
    },
    methods: {
	  // t: 1切换状态 2广告权限 3查看
	  statusBtn (t, row) {
		  if( t ==3 ) {
		    this.detailModal = true
		    this.detailId = row.orderId
		  }
	  },
      getKryOrderInquiryFn () {
        this.tableLoading = true
        getKryOrderInquiry({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime
        }).then(res => {
		  console.info(res,"查询客如云订单");
          this.tableData = res.data.result.items
          this.pages.total = res.data.result.totalRows
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getKryOrderInquiryFn()
      },
    }
  }
</script>

<style scoped>

</style>
